import { DemandeValidationDto } from '../../types/api';

/** Display state of the validation card, derived from the latest request. */
export type ValidationDisplayState =
  | 'TO_REQUEST'
  | 'PENDING'
  | 'VALIDATED'
  | 'VALIDATED_WITH_CHANGES'
  | 'INVALIDATED'
  | 'REFUSED';

/** A cancelled request (or none at all) leaves the validation to ask again. */
export const getValidationDisplayState = (
  demande: DemandeValidationDto | null | undefined
): ValidationDisplayState => {
  switch (demande?.statut) {
    case 'EnAttente':
      return 'PENDING';
    case 'Validee':
      return 'VALIDATED';
    case 'ValideeAvecModifications':
      return 'VALIDATED_WITH_CHANGES';
    case 'Invalidee':
      return 'INVALIDATED';
    case 'Refusee':
      return 'REFUSED';
    default:
      return 'TO_REQUEST';
  }
};

/** A validator answered the request: its feedback (message, clause, changes) can be shown. */
export const hasValidatorAnswer = (demande: DemandeValidationDto | null | undefined): boolean =>
  demande != null
  && demande.statut !== 'EnAttente'
  && demande.statut !== 'Annulee'
  && demande.dateReponse != null;

export const formatValidationDate = (date: Date | null | undefined): string =>
  date ? new Date(date).toLocaleDateString('fr-FR') : '';

export const formatValidationAmount = (amount: number): string =>
  new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);

/** Ceilings, deductibles and variables carry no unit in the snapshot: plain number. */
export const formatValidationNumber = (value: number | null | undefined): string =>
  value == null ? '—' : new Intl.NumberFormat('fr-FR').format(value);
